import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate, useParams} from "react-router-dom";
import {AuthContext} from "../../../config/AuthContext";
import Login from "../../Login";
import {Content} from "antd/es/layout/layout";
import AppSiderProblemesId from "./menus/AppSiderProblemesId";
import ProblemaIdEnunciat from "./content/ProblemaIdEnunciat";
import ProblemaIdEnviaments from "./content/ProblemaIdEnviaments";
import {GetJBbddProblemesId} from "../../../dao/bbdd/GetJBbddProblemesId";
import {GetUsuariIdActivitatsId} from "../../../dao/GetUsuariIdActivitatsId";
import ProblemaIdAlumnes from "./content/ProblemaIdAlumnes";
import {GetPractica} from "../../../dao/bbdd/GetPracticaId";
import AppSiderProblemesIdExamen from "./menus/AppSiderProblemesIdExamen";

const ProblemesId = () => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id_problema, id_activitat} = useParams();
    const [dades, setDades] = (useState<any>())
    const [activitat, setActivitat] = (useState<any>({isExamen: true}))
    const [pantalla, setPantalla] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_problema]);

    async function checkDades() {
        setLoading(true);
        var acti: any;
        var data = await GetJBbddProblemesId(id_problema + "");
        if (id_activitat !== undefined) {
            const act = await GetPractica(id_activitat + "");
            setActivitat(act);
            acti = await GetUsuariIdActivitatsId(userId + "", id_activitat + "");
        }

        setBreadCrumb(
            id_activitat === undefined ? [{nom: 'Home', nav: '/home'},
            {nom: 'bbdd', nav: '/database'},
            {nom: 'problemes', nav: '/database/problemes'},
            {nom: `${data.nom}`, nav: `/database/problemes/${data.id}`}]
                :
            [{nom: 'Home', nav: '/home'},
            {nom: 'bbdd', nav: '/database'},
            {nom: 'activitats', nav: `/database/activitats`},
            {nom: `${acti && acti.length > 0 && acti[0].prac}`, nav: `/database/activitats/${id_activitat}`},
            {nom: `problemes`, nav: `/database/activitats/${id_activitat}`},
            {nom: `${data.nom}`, nav: `/database/activitats/${id_activitat}/problemes/${data.id}`}]
            , true);

        setDades(data);
        setLoading(false);
    }

    function setPnt(value: number) {
        setPantalla(value);
    }

    if (isLoggedIn) {
        return (
            id_activitat === undefined || !activitat.isExamen ?
                    <>
                        <AppSiderProblemesId setPantalla={setPnt}/>
                        <Content style={{padding: '0 24px', minHeight: 280}}>
                            {pantalla === 0 && <ProblemaIdEnunciat/>}
                            {pantalla === 1 && <ProblemaIdEnviaments/>}
                            {pantalla === 2 && <ProblemaIdAlumnes/>}
                        </Content>
                    </>
                    :
                    <>
                        <AppSiderProblemesIdExamen setPantalla={setPnt}/>
                        <Content style={{padding: '0 24px', minHeight: 280}}>
                            {pantalla === 0 && <ProblemaIdEnunciat/>}
                            {pantalla === 1 && <ProblemaIdEnviaments/>}
                            {pantalla === 2 && <ProblemaIdAlumnes/>}
                        </Content>
                    </>

        );
    } else {
        return (
            <Login/>
        );
    }
};

export default ProblemesId;
